const chainTokenOnNetwork: Record<number, string> = {
  4: 'ETH', // rinkeby testnet
  1666700000: 'ONE', // harmony testnet shard 0
  1666600000: 'ONE', // harmony mainnet shard 0
};
export default chainTokenOnNetwork;
